var config = {
  apiKey: "AIzaSyBcxE9ynMPhVDdTWVywMAPgx8Tq242FWvE",
  authDomain: "malformed-synth.firebaseapp.com",
  databaseURL: "https://malformed-synth.firebaseio.com",
  storageBucket: "malformed-synth.appspot.com",
  messagingSenderId: "893642604788"
};

module.exports = config;



//////////////////
// WEBPACK FOOTER
// ./config/firebase.js
// module id = YWcn
// module chunks = 0